import React from "react";
import pipelineSvg from "assets/images/rodcut.webp"; // TODO: replace with actual pipeline svg later

// why: 형상관리(버전/릴리즈/형상 식별) 프로세스를 명료하게 정리

const CompConfig = () => {
  return (
    <main className="page-sub">
      <section className="company-main">
        <div className="company-box company" id="overview" style={{ marginTop: "80px" }}>
          <div className="company-box-title"><h3>형상관리 개요</h3></div>
          <div className="company-box-content">
            GitHub로 소스와 이슈/PR을 관리하고 Jenkins로 빌드·배포합니다. <br></br>모든 변경은 PR 리뷰와 자동 체크(린트/테스트)를 통과해야 하며, 태그로 릴리스를 추적합니다.
          </div>
        </div>

        <div className="company-box" id="branching">
          <div className="company-box-title"><h3>브랜치 전략</h3></div>
          <div className="company-box-content">
            main은 보호하고, 기능 개발은 feature/* 브랜치에서 진행합니다. 머지는 PR로만 가능하며 Squash Merge를 기본으로 사용합니다. 필요 시 release/* 브랜치로 안정화 후 태깅합니다.
          </div>
        </div>

        <div className="company-box" id="policy">
          <div className="company-box-title"><h3>커밋 · PR 정책</h3></div>
          <div className="company-box-content">
            Conventional Commits를 따르며, PR에는 변경 요약·테스트 방법·체크리스트를 포함합니다. 최소 1명 이상의 리뷰와 Jenkins 체크 통과가 필수입니다.
          </div>
        </div>

        <div className="company-box" id="versioning">
          <div className="company-box-title"><h3>버저닝 · 릴리스</h3></div>
          <div className="company-box-content">
            SemVer(주버전.부버전.수정) 규칙을 적용하고, 릴리스는 vX.Y.Z 태그로 식별합니다. 변경 이력은 커밋 타입을 기반으로 자동 생성합니다.
          </div>
        </div>

        <div className="company-box" id="pipeline">
          <div className="company-box-title"><h3>CI/CD 파이프라인</h3></div>
          <div className="company-box-content">
            GitHub 푸시/PR → Jenkins 멀티브랜치가 트리거되어 설치·린트·테스트·보안 점검 후 아티팩트를 생성하고, 승인 절차를 거쳐 Dev/Stage/Prod 순서로 배포합니다.
          </div>
        </div>

        <div className="company-box" id="deploy">
          <div className="company-box-title"><h3>배포 · 롤백</h3></div>
          <div className="company-box-content">
            웹 서비스는 Blue-Green 또는 Rolling으로 무중단 배포하며, 실패 시 직전 태그로 즉시 롤백합니다. DB 스키마 변경은 업/다운 스크립트를 분리해 관리합니다.
          </div>
        </div>

        <div className="company-box" id="security">
          <div className="company-box-title"><h3>보안 · 비밀정보</h3></div>
          <div className="company-box-content">
            Jenkins Credentials와 GitHub Secrets로 비밀정보를 주입합니다. 보호 브랜치·필수 리뷰·필수 체크로 기본 보안을 강화하고, 의존성/취약점 스캔을 상시 수행합니다.
          </div>
        </div>
      </section>
    </main>
  );
};

export default CompConfig;


